import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const FullscreenToggle = ({ onExpand, onContract }) => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	const handleExpand = () => {
		setIsFullscreen(true);
		onExpand();
	};
	const handleContract = () => {
		setIsFullscreen(false);
		onContract();
	};

	return (
		<div className="pull-right">
			<button
				onClick={handleExpand}
				className={cn('btn', 'btn-small', 'fullscreen', { hidden: isFullscreen})}
			>
				<em className="icon-size-fullscreen" />
			</button>
			<button
				onClick={handleContract}
				// className="btn btn-small actual hidden"
				className={cn('btn', 'btn-small', 'actual', { hidden: !isFullscreen})}
			>
				<em className="icon-size-actual" />
			</button>
		</div>
	);
};

FullscreenToggle.propTypes = {
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired
};

export default FullscreenToggle;
